import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{t 'tool_mmc_importer.headline'}}
    </:title>

    <:body>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.mmcImportSettings}}
        as |form|
      >
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='settings' as |fieldset|>
              <fieldset.field @property='upc' />
              <div class='o-layout'>
                <div class='o-layout__item u-1/1 u-1/2@tablet'>
                  <fieldset.field @property='cover' @type='checkbox' />
                </div>
                <div class='o-layout__item u-1/1 u-1/2@tablet'>
                  <fieldset.field @property='force' @type='checkbox' />
                </div>
              </div>

              <Button
                @label={{t 'tool_mmc_importer.import'}}
                @icon='download'
                {{on 'click' (perform @controller.mmcImport)}}
              />
            </form.fieldset>
          </div>
          <div class='o-layout__item u-1/1 u-1/2@tablet'></div>
        </div>
      </Form>
    </:body>
  </Window>
</template>
